/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TrackPageViewMutationVariables = Types.Exact<{
	trackPageViewInput: Types.TrackPageViewInput;
}>;

export type TrackPageViewMutation = {
	__typename?: 'Mutation';
	trackPageView: { __typename?: 'EventCreated'; messageId?: string | null };
};

export const TrackPageViewDocument = gql`
	mutation TrackPageView($trackPageViewInput: TrackPageViewInput!) {
		trackPageView(trackInput: $trackPageViewInput) {
			... on EventCreated {
				messageId
			}
		}
	}
`;
export type TrackPageViewMutationFn = Apollo.MutationFunction<
	TrackPageViewMutation,
	TrackPageViewMutationVariables
>;

/**
 * __useTrackPageViewMutation__
 *
 * To run a mutation, you first call `useTrackPageViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackPageViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackPageViewMutation, { data, loading, error }] = useTrackPageViewMutation({
 *   variables: {
 *      trackPageViewInput: // value for 'trackPageViewInput'
 *   },
 * });
 */
export function useTrackPageViewMutation(
	baseOptions?: Apollo.MutationHookOptions<
		TrackPageViewMutation,
		TrackPageViewMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		TrackPageViewMutation,
		TrackPageViewMutationVariables
	>(TrackPageViewDocument, options);
}
export type TrackPageViewMutationHookResult = ReturnType<
	typeof useTrackPageViewMutation
>;
export type TrackPageViewMutationResult =
	Apollo.MutationResult<TrackPageViewMutation>;
export type TrackPageViewMutationOptions = Apollo.BaseMutationOptions<
	TrackPageViewMutation,
	TrackPageViewMutationVariables
>;
